import { Base } from './base-model';
import { LessonSong } from './lesson-song';
import { Type } from 'class-transformer';
import { Course } from './course'

export class Lesson extends Base {
    name: string
    notes: string
    @Type(() => LessonSong)
    songs: LessonSong[]
    numSongs: number
    classType: Course.ClassType
    description: string

    static defaults(): Lesson {
        const lesson = new Lesson()
        lesson.name = ''
        lesson.notes = ''
        lesson.songs = [
            LessonSong.defaults(),
            LessonSong.defaults(),
            LessonSong.defaults(),
            LessonSong.defaults(),
            LessonSong.defaults(),
            LessonSong.defaults(),
            LessonSong.defaults(),
            LessonSong.defaults(),
            LessonSong.defaults(),
            LessonSong.defaults(),
        ]
        lesson.numSongs = lesson.songs.length
        lesson.classType = Course.ClassType.None
        lesson.description = ''
        return lesson
    }

    setSendDate() {
        super.setSendDate()
        this.songs.forEach( (lessonSong: LessonSong) => lessonSong.setSendDate() )
    }

    resetSendDate() {
        super.resetSendDate()
        this.songs.forEach( (lessonSong: LessonSong) => lessonSong.resetSendDate() )
    }

    copyFrom(lesson: Lesson) {
        super.copyFrom(lesson)
        this.name = lesson.name
        this.notes = lesson.notes
        this.description = lesson.description
        this.classType = lesson.classType
        this.songs = lesson.songs.map((lessonSong: LessonSong) => {
            const existingSong = this.songs.find((ls: LessonSong) => ls.uuid === lessonSong.uuid)
            if (existingSong !== undefined) {
                existingSong.copyFrom(lessonSong)
                return existingSong
            }
            return lessonSong
        })
    }

    unsavedCopy(): Lesson {
        const lesson = super.unsavedCopy() as Lesson
        lesson.songs = lesson.songs.map( (song: LessonSong) => song.unsavedCopy() )
        return lesson
    }

    findLessonSong(uuid: string): LessonSong {
        return this.songs.find( (lessonSong: LessonSong) => uuid && (lessonSong.uuid === uuid) )
    }

    indexOfLessonSong(uuid: string): number {
        return this.songs.findIndex( (lessonSong: LessonSong) => uuid && (lessonSong.uuid === uuid) )
    }

}

